<template>
  <div class="d-profile-direct-submissions">
    <div class="panel background-grey text-center padding-top-8em padding-bottom-5em">
      <img
        alt="Direct submissions"
        class="space-bottom-3em"
        :src="panelImgSrc"
        style="width: 140px;"
      >

      <h2>
        I can review your book!
      </h2>

      <p class="large space-top-2em">
        Submit your book to me directly on Reedsy Discovery
      </p>

      <a
        class="button button-lg button-yellow space-top-2em"
        :href="submitUrl"
        title="Submit your book to me"
        type="button"
        @click="submit"
      >
        Submit your book to me
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
    submissionUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    panelImgSrc: require('@d-assets/books-glasses-round.svg'),
    submitUrl: null,
  }),
  mounted() {
    this.setSubmitUrl();
  },
  methods: {
    setSubmitUrl() {
      if (!this.isUserSignedIn) {
        return;
      }

      this.$set(this, 'submitUrl', this.submissionUrl);
    },

    submit() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }
    },
  },
};
</script>
